import { render, staticRenderFns } from "./EditBarView.vue?vue&type=template&id=576f985e&scoped=true"
import script from "./EditBarView.vue?vue&type=script&lang=js"
export * from "./EditBarView.vue?vue&type=script&lang=js"
import style0 from "./EditBarView.vue?vue&type=style&index=0&id=576f985e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576f985e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('576f985e')) {
      api.createRecord('576f985e', component.options)
    } else {
      api.reload('576f985e', component.options)
    }
    module.hot.accept("./EditBarView.vue?vue&type=template&id=576f985e&scoped=true", function () {
      api.rerender('576f985e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/EditBarView.vue"
export default component.exports